export const headers = [
  {
    headerName: 'Cod. Flota',
    field: 'cod_flota',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'Nombre de Flota',
    field: '__nom_flota',
    sortable: true,
    sort: 'asc',
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'Total',
    field: 'total_vehiculos',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'Transm. Hoy',
    field: 'transm_today',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: '%',
    field: 'transm_percent',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'NT 1-7 Días',
    field: 'nt_week',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: '%',
    field: 'nt_week_percent',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'NT 8-30 Días',
    field: 'nt_month',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: '%',
    field: 'nt_month_percent',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'NT +30 Días',
    field: 'nt_plusmonth',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: '%',
    field: 'nt_plusmonth_percent',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'NT Nunca',
    field: 'nt_never',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: '%',
    field: 'nt_never_percent',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
];
